import { noun } from 'plural-ru';

export default function formatParticipantsCounter(val) {
  return noun(val, '%d участник', '%d участника', '%d участников');
}
